import React from 'react';
import ButtonWithIcon from '../components/ButtonWithIcon';
import I18n from '../i18n/I18n';
import { Icons } from '../icons/Icons';

export default ({ onClick, disabled = false }: { onClick: () => void; disabled?: boolean }) => {
    return (
        <ButtonWithIcon
            label={<I18n token="common.label.file" />}
            onClick={onClick}
            Icon={Icons.FileUpload}
            fontSize="small"
            sx={{ width: 'fit-content' }}
            disabled={disabled}
        />
    );
};
